(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,4963],{

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(97298);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41418);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);



var AnimatedBorder = function(param) {
    var _delay = param.delay, delay = _delay === void 0 ? 0 : _delay;
    /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xuv, {
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        borderRadius: 100,
        sx: function(param) {
            var palette = param.palette;
            var ref;
            return {
                "@keyframes wave": {
                    "0%": {
                        transform: "scale(1)",
                        opacity: 1
                    },
                    "100%": {
                        transform: "scale(1.75)",
                        opacity: 0
                    }
                },
                outline: "1px solid",
                outlineColor: palette.mode === "dark" ? "#434343" : (ref = palette.bg) === null || ref === void 0 ? void 0 : ref[100],
                animation: "wave 3s ease infinite",
                animationDelay: "".concat(delay, "s")
            };
        }
    });
};
var Loading = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Stack */ .Kqy, {
        position: "relative",
        alignItems: "center",
        justifyContent: "center",
        width: 88,
        height: 88,
        borderRadius: 100,
        bgcolor: "brand.main",
        sx: {
            filter: "drop-shadow(0px 0px 20px rgba(13, 180, 140, 0.33))"
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .CircularProgress */ .D8x, {
                size: 54,
                sx: {
                    color: "#f5f5f5"
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(AnimatedBorder, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(AnimatedBorder, {
                delay: 1
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(AnimatedBorder, {
                delay: 2
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(Loading));


/***/ }),

/***/ 51466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function useModalState() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isOpen = ref[0], toggleIsOpen = ref[1];
    var closeModal = function() {
        toggleIsOpen(false);
    };
    var openModal = function() {
        toggleIsOpen(true);
    };
    return {
        isOpen: isOpen,
        openModal: openModal,
        closeModal: closeModal
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useModalState);


/***/ }),

/***/ 97298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ./src/hooks/index.ts + 10 modules
var hooks = __webpack_require__(68062);
// EXTERNAL MODULE: ./src/views/Modals/SignModal.tsx
var SignModal = __webpack_require__(4963);
// EXTERNAL MODULE: ../../packages/cyberlab-uikit/src/index.ts + 192 modules
var src = __webpack_require__(41418);
// EXTERNAL MODULE: ./src/hooks/useModalState.ts
var useModalState = __webpack_require__(51466);
// EXTERNAL MODULE: ../../packages/pwa-icons/index.ts + 1 modules
var pwa_icons = __webpack_require__(78221);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(45760);
// EXTERNAL MODULE: ./src/hooks/passkey/usePasskey.ts
var usePasskey = __webpack_require__(27408);
// EXTERNAL MODULE: ../../packages/service/pwa/generated/graphql.ts
var graphql = __webpack_require__(51499);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/format/index.js + 16 modules
var format = __webpack_require__(62650);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/views/Passkey/CreateAccountModal.tsx















function CreateAccountModal(props) {
    var ref = (0,usePasskey/* default */.Z)(), handleCreate = ref.handleCreate, isCreating = ref.isCreating, handleLogin = ref.handleLogin, isLogining = ref.isLogining;
    var changeAccessToken = (0,hooks/* useAuth */.aC)().changeAccessToken;
    var replace = (0,next_router.useRouter)().replace;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useTurnkeyUserRegisterMutation */.PP7)({
        selectFromResult: function selectFromResult(param) {
            var data = param.data;
            return {
                isRegistered: (data === null || data === void 0 ? void 0 : data.turnkeyUserRegister.status) === graphql/* RegisterTurnkeyUserResponse_Status.Success */.pw6.Success
            };
        }
    }), 2), registerTurnkey = ref1[0], isRegistered = ref1[1].isRegistered;
    var handleRegister = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var username, register, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        username = "".concat((0,format/* default */.Z)(new Date(), "yyyy-MM-dd HH:mm:ss"), " CyberAccount");
                        register = function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(request) {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            return _ctx.abrupt("return", registerTurnkey({
                                                request: request
                                            }).then(function(res) {
                                                return {
                                                    isSuccess: "data" in res && res.data.turnkeyUserRegister.status === graphql/* RegisterTurnkeyUserResponse_Status.Success */.pw6.Success
                                                };
                                            }));
                                        case 1:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function register(request) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        _ctx.next = 4;
                        return handleCreate({
                            username: username,
                            register: register
                        });
                    case 4:
                        res = _ctx.sent;
                        if (!res.isSuccess) {
                            ;
                            (ref = props.onClose) === null || ref === void 0 ? void 0 : ref.call(props);
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleRegister() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var handleSuccess;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        handleSuccess = function(user) {
                            var ref;
                            if (user === null || user === void 0 ? void 0 : (ref = user.privateInfo) === null || ref === void 0 ? void 0 : ref.accessToken) {
                                changeAccessToken(user.privateInfo.accessToken);
                                replace("/home");
                            }
                        };
                        _ctx.next = 3;
                        return handleLogin({
                            onSuccess: handleSuccess
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (props.open && !isCreating) {
            handleRegister();
        }
    }, [
        props.open
    ]);
    var renderContent = function() {
        if (isCreating || isLogining) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kCb, {
                height: "80%",
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loading/* default */.Z, {})
            });
        }
        if (!isCreating && isRegistered) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kqy, {
                        gap: 18 / 8,
                        alignItems: "center",
                        mt: 2,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
                                name: "icon-passkey-line",
                                size: 50
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xvT, {
                                bold: true,
                                variant: "subtitle1",
                                textAlign: "center",
                                children: "One Last Step!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zxk, {
                        onClick: handleConfirm,
                        sx: {
                            mt: 7
                        },
                        variant: "contained",
                        color: "primary",
                        children: "Confirm Authentication"
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Drawer */.dys, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        contentSx: {
            height: 265,
            mt: "-1px"
        },
        title: isCreating || isRegistered ? "Login with Passkey" : "Create Account",
        children: renderContent()
    }));
}
/* harmony default export */ var Passkey_CreateAccountModal = (CreateAccountModal);

;// CONCATENATED MODULE: ./src/views/Passkey/CreateButton.tsx





function CreateButton() {
    var ref = (0,useModalState/* default */.Z)(), isCreateAccountModalOpen = ref.isOpen, openCreateModal = ref.openModal, closeCreateModal = ref.closeModal;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kqy, {
        gap: 2,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* LoadingButton */.flC, {
                variant: "contained",
                onClick: openCreateModal,
                fullWidth: true,
                startIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
                    name: "icon-add-line",
                    color: "text.1000"
                }),
                sx: {
                    "& .MuiButton-startIcon": {
                        marginRight: "10px"
                    }
                },
                children: "Sign up with a passkey"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Passkey_CreateAccountModal, {
                onClose: closeCreateModal,
                open: isCreateAccountModalOpen
            })
        ]
    });
}
/* harmony default export */ var Passkey_CreateButton = (CreateButton);

;// CONCATENATED MODULE: ./src/views/Passkey/LoginButton.tsx






function LoginButton() {
    var ref = (0,usePasskey/* default */.Z)(), turnkeyLogin = ref.handleLogin, isLogining = ref.isLogining;
    var changeAccessToken = (0,hooks/* useAuth */.aC)().changeAccessToken;
    var replace = (0,next_router.useRouter)().replace;
    var handleLogin = function() {
        turnkeyLogin({
            onSuccess: function onSuccess(data) {
                var ref;
                if (data === null || data === void 0 ? void 0 : (ref = data.privateInfo) === null || ref === void 0 ? void 0 : ref.accessToken) {
                    changeAccessToken(data.privateInfo.accessToken);
                    replace("/home");
                }
            }
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* LoadingButton */.flC, {
        loading: isLogining,
        variant: "outlined",
        onClick: handleLogin,
        fullWidth: true,
        startIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
            name: "icon-key-line",
            color: "#ffffff"
        }),
        sx: {
            "& .MuiButton-startIcon": {
                marginRight: "10px"
            }
        },
        children: "Sign in with your passkey"
    });
}
/* harmony default export */ var Passkey_LoginButton = (LoginButton);

// EXTERNAL MODULE: ../../node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69702);
// EXTERNAL MODULE: ../../packages/utils/index.ts + 27 modules
var utils = __webpack_require__(26292);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/ThemeProvider.js + 6 modules
var ThemeProvider = __webpack_require__(70704);
;// CONCATENATED MODULE: ./src/pages/index.tsx












function Landing(props) {
    var ref = (0,hooks/* useAuth */.aC)(), isLoggedIn = ref.isLoggedIn, login = ref.login, signAndVerify = ref.signAndVerify;
    var isConnected = (0,dist/* useAccount */.mA)().isConnected;
    var ref1 = (0,SignModal.useSignModal)(), openSignModal = ref1.openModal, closeSignModal = ref1.closeModal;
    var router = (0,next_router.useRouter)();
    (0,utils/* useIsomorphicLayoutEffect */.LI)(function() {
        if (isLoggedIn) {
            router.replace("/home");
        }
    }, [
        isLoggedIn
    ]);
    (0,react.useEffect)(function() {
        if (isConnected && !isLoggedIn) {
            setTimeout(function() {
                openSignModal();
            }, 250);
        } else if (isLoggedIn) {
            closeSignModal();
        }
    }, [
        isConnected,
        isLoggedIn
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ThemeProvider/* default */.Z, {
        theme: src/* darkTheme */.$_G,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Stack */.Kqy, {
            height: "calc(100vh - 56px)",
            position: "relative",
            sx: {
                backgroundImage: "url(/assets/bg/login-bg-new.png)",
                backgroundSize: "100%",
                justifyContent: "center",
                backgroundRepeat: "no-repeat"
            },
            children: !isLoggedIn ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kqy, {
                        flex: "auto",
                        pt: 4,
                        pl: 3,
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                src: "/assets/logos/link3-logo-full-white.svg",
                                width: 112,
                                height: 25,
                                loading: "eager"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kqy, {
                                justifyContent: "space-between",
                                gap: 3,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xvT, {
                                        variant: "h5",
                                        bold: true,
                                        fontStyle: "italic",
                                        children: "Professional networking reimagined!"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Box */.xuv, {
                                        height: "1px",
                                        width: "100%",
                                        sx: {
                                            background: "linear-gradient(270deg, rgba(255, 255, 255, 0.00) 21.68%, #FFF 63.58%, rgba(255, 255, 255, 0.00) 100%)"
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kqy, {
                        gap: 3,
                        height: 422,
                        flex: "none",
                        bgcolor: "rgba(20,20,20,0.2)",
                        pt: 4,
                        px: 2,
                        sx: {
                            backdropFilter: "blur(50px)"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kqy, {
                                gap: 3,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xvT, {
                                        color: "text.100",
                                        bold: true,
                                        children: "New to Link3?"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Passkey_CreateButton, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kqy, {
                                gap: 3,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xvT, {
                                        color: "text.100",
                                        bold: true,
                                        children: "Existing user?"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kqy, {
                                        alignItems: "center",
                                        gap: 2,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Passkey_LoginButton, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* LoadingButton */.flC, {
                                                variant: isConnected ? "contained" : "outlined",
                                                onClick: isConnected ? function() {
                                                    return openSignModal();
                                                } : login.login,
                                                fullWidth: true,
                                                startIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* default */.Z, {
                                                    name: "icon-wallet-outlined",
                                                    color: isConnected ? "#000" : "text.primary"
                                                }),
                                                sx: {
                                                    "& .MuiButton-startIcon": {
                                                        marginRight: "10px"
                                                    }
                                                },
                                                loading: login.isLoading || signAndVerify.isLoading,
                                                children: isConnected ? "Verify your address" : "Connect Wallet"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xvT, {
                                                mt: -1,
                                                variant: "body2",
                                                color: "text.250",
                                                children: "*Recommended for existing users"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : null
        })
    });
}
/* harmony default export */ var pages = (Landing);


/***/ }),

/***/ 4963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useSignModal": function() { return /* binding */ useSignModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98788);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52903);
/* harmony import */ var _component_Loading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45760);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68062);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7229);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41418);
/* harmony import */ var _link3_pwa_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78221);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94449);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69702);











function SignModal() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), isSigning = ref[0], toggleIsSigning = ref[1];
    var ref1 = useSignModal(), isOpen = ref1.isOpen, sign = ref1.sign, closeModal = ref1.closeModal, openModal = ref1.openModal;
    var signAndVerify = (0,_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .aC)().signAndVerify;
    var ref2 = (0,wagmi__WEBPACK_IMPORTED_MODULE_8__/* .useAccount */ .mA)(), isConnecting = ref2.isConnecting, isConnected = ref2.isConnected;
    var disconnectAsync = (0,wagmi__WEBPACK_IMPORTED_MODULE_8__/* .useDisconnect */ .qL)().disconnectAsync;
    var isLoading = isConnecting || isSigning;
    var handleSign = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        toggleIsSigning(true);
                        _ctx.next = 4;
                        return sign ? sign() : signAndVerify.signAndVerify();
                    case 4:
                        closeModal();
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        toggleIsSigning(false);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function handleSign() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isConnected) {
                            _ctx.next = 3;
                            break;
                        }
                        _ctx.next = 3;
                        return disconnectAsync();
                    case 3:
                        closeModal();
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCancel() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (!isOpen) {
            return function() {
                toggleIsSigning(false);
            };
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Drawer */ .dys, {
        open: isOpen,
        needCloseIcon: !isLoading,
        contentSx: {
            height: 342
        },
        title: "",
        onClose: isLoading ? undefined : handleCancel,
        children: isLoading || isConnecting ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Stack */ .Kqy, {
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_component_Loading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xvT, {
                    color: "text.250",
                    variant: "body2",
                    textAlign: "center",
                    mt: 8,
                    sx: {
                        transition: "none"
                    },
                    children: "If it remains in loading for a long time, please check your network status or confirm again within the wallet app."
                })
            ]
        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .Fragment */ .HY, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Stack */ .Kqy, {
                    gap: 1.5,
                    alignItems: "center",
                    mt: 20 / 8,
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_link3_pwa_icons__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .J, {
                            name: "icon-body-sign-line",
                            size: 50
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xvT, {
                            bold: true,
                            children: "Verify your account"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xvT, {
                            variant: "body2",
                            textAlign: "center",
                            children: "To finish connecting, you must sign a message in your wallet to verify that you are the owner of this account."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kCb, {
                    gap: 2,
                    mt: 5,
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zxk, {
                            onClick: handleCancel,
                            disabled: isLoading,
                            variant: "outlined",
                            fullWidth: true,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .LoadingButton */ .flC, {
                            loading: isLoading,
                            onClick: handleSign,
                            variant: "contained",
                            fullWidth: true,
                            children: "Send Message"
                        })
                    ]
                })
            ]
        })
    });
}
var useSignModal = function() {
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return state.global.signModalStatus;
    }), isOpen = ref.isOpen, sign = ref.sign;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
    var closeModal = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    dispatch(_store__WEBPACK_IMPORTED_MODULE_3__/* .actions.global.setSignModalStatus */ .N.global.setSignModalStatus({
                        isOpen: false
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    var openModal = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function(sign) {
        dispatch(_store__WEBPACK_IMPORTED_MODULE_3__/* .actions.global.setSignModalStatus */ .N.global.setSignModalStatus({
            isOpen: true,
            sign: sign
        }));
    }, []);
    return {
        isOpen: isOpen,
        sign: sign,
        closeModal: closeModal,
        openModal: openModal
    };
};
/* harmony default export */ __webpack_exports__["default"] = (SignModal);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);